import { render, staticRenderFns } from "./RequestAdditionalInformation.vue?vue&type=template&id=8e32b45e&scoped=true"
import script from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"
import style0 from "./RequestAdditionalInformation.vue?vue&type=style&index=0&id=8e32b45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e32b45e",
  null
  
)

export default component.exports